<template>
  <section class="flex column">
    <div>
      <h3>Editar Conversão Personalizada</h3>
    </div>
    <section class="box flex-1 w100 margin-top-s">
      <div class="box-content">
        <div class="flex w100">
          <div class="item flex-1 ">
            <label>Nome:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
          <div class="item margin-top-s flex-1">
            <label>Plataforma:</label>
            <select class="input" v-model="newCustomConversion.platform">
              <option value="">Seleciona</option>
              <option
                v-for="(f, index) in listPlataform"
                :key="index"
                :value="f.value"
                :selected="f.value === newCustomConversion.platform"
              >
                {{ f.name }}
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="newCustomConversion.platform === 'GADS'"
          class="flex margin-top-s"
        >
          <div class="item ">
            <label>Conversion Id:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
          <div class="item ">
            <label>Rótulo da Conversão:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
          <div class="item ">
            <label>Valor da Conversão:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
        </div>
        <div
          v-if="newCustomConversion.platform === 'FBADS'"
          class="flex margin-top-s"
        >
          <div class="item">
            <label>Nome do Evento:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
          <div class="item">
            <label>Nome do Produto:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
          <div class="item">
            <label>Valor da Conversão:</label>
            <input
              class="input margin-top-s"
              v-model="newCustomConversion.name"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="flex margin-top-l">
      <h3>Acionadores</h3>
    </section>
    <section class="box flex-1 w100 margin-top-s">
      <div class="box-content">
        <div class="flex w100">
          <div class="flex column w100">
            <div class="item">
              <div class="button primary" @click="openModalActionEdit()">
                Adicionar Acionador
              </div>
            </div>
            
            <div class="item flex-1 w100">
              <div class="list-itens flex column w100">
                <div
                  class="box flex-1 w100 step-item"
                  v-for="(fs, index) in actives"
                  :key="index"
                >
                  <div class="box-content">
                    <div class="flex-1 w100">
                      <div class="flex middle row">
                        <div class="flex-3">
                          <div class="flex middle row">
                            <div class="flex-1 name">
                              <div>Tipo: {{ fs.name }}</div>
                              <div class="margin-top-s">
                                Tipo:
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="action">
                          <div class="flex end">
                            <div class="button primary" @click="openModalActionEdit(fs)">
                              EDITAR
                            </div>
                            <div
                              class="button primary"
                              @click="openToDelete(fs.id)"
                              style="margin-left: 8px"
                            >
                              DELETAR
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="flex w100 ">
                          <div v-if="false" class="flex-1 flex w100">
                            <logical-expression-builder
                              :initialOptions="opcoesIniciais"
                              @save="processarExpressao"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEmptyActives" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum acionador. Crie seu primeiro acionador para começar a disparar sua Conversão.
          </p>
        </div>
      </div>

      <div v-if="loadingActives" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      largebox="true"
      @close="closeModalActionEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newActive.name"
                autocomplete="off"
              />
            </div>
            <div class="flex-1">
              <div class="margin-top-s flex-1">
                <label>Tipo de Acionador:</label>
                <select class="input" v-model="newActive.active">
                  <option value="">Seleciona</option>
                  <option
                    v-for="(f, index) in listActives"
                    :key="index"
                    :value="f.value"
                    :selected="f.value === newActive.typeActive"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrupdateFunnelStep()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Acionador?"
      @cancel="
        showModalDelete = false;
        selectedActiveId = null;
      "
      @accept="deleteActive(selectedActiveId)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
// import LogicalExpressionBuilder from "@/components/logical/LogicalExpressionBuilder";

import {
  getCustomConversion,
  updateCustomConversion,
  deleteCustomConversion,
} from "@/services/customConversion";

const EMPTY_CUSTOM_CONVER = {
  name: "",
  platform: "FBADS",
};

const EMPTY_ACTIVE = {
  name: "",
};


export default {
  name: "custom-conversion-new",
  components: {
    Modal,
    ModalConfirm,
    // LogicalExpressionBuilder,
  },
  props: ["conv_id"],
  data() {
    return {
      loading: false,
      loadingActives: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedActiveId: null,
      newCustomConversion: Object.assign({}, EMPTY_CUSTOM_CONVER),
      newActive: Object.assign({}, EMPTY_ACTIVE),
      listPlataform: [
        { name: "Google", value: "GADS" },
        { name: "Facebook", value: "FBADS" },
      ],
      listActives: [
        { name: "Visita em Página", value: "PAGEVIEW" },
        { name: "Tempo de Visita em Página", value: "PAGEVIEW-TIME" },
        { name: "Scrool de página", value: "SCROLL" },
        { name: "Preencheu E-Mail", value: "LEAD" },
        { name: "Fez uma Compra", value: "PURCHASE" },
        { name: "Player de Vídeo", value: "PLAY" },
        { name: "Tempo de Player em Vídeo", value: "PLAY-TIME" },
        { name: "Clique em Botão", value: "CLICK" },
        { name: "Visualização de elementos", value: "VIEW-CONTENT" },
      ],
      actives: [
        { id: 0, name: "Teste", status: "ACTIVE" },
        { id: 0, name: "Teste", status: "ACTIVE" },
        { id: 0, name: "Teste", status: "ACTIVE" },
      ],
    };
  },
  mounted() {
    if (this.conv_id) {
      this.getCustomConversion();
    }
  },
  watch: {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isEmpty() {
      return this.totalfunnelSteps === 0 && !this.loading;
    },
    isEdit() {
      if (this.newCustomConversionStep && this.newCustomConversionStep.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    openModalActionEdit(ac) {
      this.showModalCreateOrUpdate = true
      if (ac) {
        this.newAction = ac
      }
    },
    closeModalActionEdit() {
      this.showModalCreateOrUpdate = false
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedStepId = sl;
    },
    getCustomConversion() {
      this.loading = true;
      getCustomConversion(this.conv_id)
        .then((result) => {
          this.newCustomConversion = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateCustomConversion() {
      let params = {
        name: this.newCustomConversion.name,
      };

      updateCustomConversion(this.conv_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Funil editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteCustomConversion(funnelId) {
      deleteCustomConversion(funnelId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Funil deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedActiveId = null;
          this.showModalDelete = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.grid-flex .box + .box,
.flex .box + .box {
  margin-left: 0px;
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}
.step-item {
  border-radius: 8px;
  border: 1px solid #c3c3c3;
  margin-top: 8px;
}
</style>
